// ブログ用スワイパー

document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.ranking-swiper', {
        // デフォルト（スマホ）
        slidesPerView: 2.2,
        spaceBetween: 15,
        freeMode: {
            enabled: true,        // 決まった位置で止まらず、自由に動くようにする
            sticky: false,        // スライドの境目でピタッと止まる機能をオフ
            momentumRatio: 1,    // 慣性の強さ（大きくするとより長く滑る）
            momentumVelocityRatio: 1, // 慣性の初速
        },
        allowTouchMove: true, 
        grabCursor: true,
        
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        // ブレイクポイント（PC）
        breakpoints: {
            1000: {
                slidesPerView: 3.2,
                slidesPerGroup: 3,
                spaceBetween: 15,
                        freeMode: {
                            enabled: false,        // 決まった位置で止まらず、自由に動くようにする
                            sticky: true,        // スライドの境目でピタッと止まる機能をオフ
                            momentumRatio: 1,    // 慣性の強さ（大きくするとより長く滑る）
                            momentumVelocityRatio: 1, // 慣性の初速
                        },
            }
        },
        watchOverflow: true,
    });
});
